"use client";

import { IStoryBlokComponent } from "apps/website/components/page/api.types";

import SectionFeastTrial from "../../section/SectionFeastTrial/SectionFeastTrial";

export interface IStoryBlokFeastTrial {
  _uid: string;
  component: "section_feast_trial";
}

export const StoryBlokFeastTrial = ({ blok: _blok }: IStoryBlokComponent<IStoryBlokFeastTrial>) => (
  <SectionFeastTrial />
);
